import { useContent } from "../../i18n/content";
import { SectionHeader } from "../SectionHeader";
import { Reveal } from "../motion/Reveal";

export const AssetStrategy = () => {
    const { ui, site } = useContent();
    return (
    <section data-testid="asset-strategy-section" className="relative py-24 lg:py-32">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <SectionHeader
                chapter={ui.asset.chapter}
                overline={ui.asset.overline}
                title={ui.asset.title}
                description={ui.asset.description}
            />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-[#4a4c42] border border-[#4a4c42]">
                {site.assetStages.map((s, i) => (
                    <Reveal key={s.num} delay={0.12 * i} className="h-full">
                        <article
                            data-testid={`asset-stage-${s.num}`}
                            className="group relative h-full bg-[#292a24] p-8 lg:p-10 flex flex-col hover:bg-[#32332c] transition-colors duration-500"
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-display text-6xl lg:text-7xl font-extrabold text-stroke-yellow leading-none">
                                    {s.num}
                                </span>
                                <span className="font-display text-[10px] font-bold tracking-[0.24em] uppercase text-[#f6c422] border border-[#f6c422]/40 px-3 py-1.5">
                                    {s.period}
                                </span>
                            </div>

                            <p className="overline-text !text-[10px] mt-8 mb-2">{ui.asset.stage} {s.num}</p>
                            <h3 className="font-display text-xl lg:text-2xl font-extrabold uppercase tracking-wide text-white leading-tight">
                                {s.title}
                            </h3>

                            <div className="mt-8 space-y-6 flex-1">
                                {s.groups.map((g) => (
                                    <div key={g.label}>
                                        <p className="font-display text-[10px] font-semibold tracking-[0.24em] uppercase text-[#a2a59d]/70 mb-3">
                                            {g.label}
                                        </p>
                                        <ul className="space-y-2">
                                            {g.items.map((item) => (
                                                <li key={item} className="flex items-center gap-3 text-sm text-white/85">
                                                    <span className="w-1.5 h-1.5 rotate-45 bg-[#f6c422]/80 shrink-0" />
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>

                            <div
                                data-testid={`asset-stage-highlight-${s.num}`}
                                className="mt-10 bg-[#f6c422] px-5 py-4"
                            >
                                <p className="font-display text-sm font-extrabold tracking-wide uppercase text-[#292a24]">
                                    {s.highlight}
                                </p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
    );
};
